import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'demo-form-layout',
    templateUrl: './demo-form-layout.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoFormLayoutComponent implements OnInit {
    form!: FormGroup;
    sectionFill: 'clear' | 'solid' = 'solid';
    buttonsFloat: 'top' | 'bottom' = 'bottom';
    warningLines: 'solid' | 'none' = 'solid';
    showWarning = true;

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.email]),
            notes: new FormControl(''),
        });
    }

    toggleSectionFill() {
        this.sectionFill = this.sectionFill === 'solid' ? 'clear' : 'solid';
        this.change.markForCheck();
    }

    toggleButtonsFloat() {
        this.buttonsFloat = this.buttonsFloat === 'bottom' ? 'top' : 'bottom';
        this.change.markForCheck();
    }

    toggleWarningLines() {
        this.warningLines = this.warningLines === 'solid' ? 'none' : 'solid';
        this.change.markForCheck();
    }

    toggleWarning() {
        this.showWarning = !this.showWarning;
        this.change.markForCheck();
    }
}
